import { Loader2 } from "lucide-react";
import { Link } from "react-router";

import { useAdminActivityActions, useAdminActivityAnalytics, useAdminUsers } from "@/lib/api";

import { AdminShell } from "../admin-shell";
import { ActivityDashboard } from "./activity-dashboard";

export function AdminActivityPage() {
  const analyticsQuery = useAdminActivityAnalytics(30);
  const usersQuery = useAdminUsers();
  const actionsQuery = useAdminActivityActions();

  const isLoading = analyticsQuery.isLoading || usersQuery.isLoading || actionsQuery.isLoading;
  const isError = analyticsQuery.isError || usersQuery.isError || actionsQuery.isError;

  return (
    <AdminShell title="Activity">
      {isLoading ? (
        <div className="border-border flex justify-center rounded-2xl border bg-white py-16">
          <Loader2 className="text-muted h-6 w-6 animate-spin" />
        </div>
      ) : isError || !analyticsQuery.data ? (
        <div className="border-border rounded-2xl border bg-white py-12 text-center">
          <p className="text-muted text-[15px]">
            Could not load activity. Please{" "}
            <button
              type="button"
              onClick={() => {
                void analyticsQuery.refetch();
                void usersQuery.refetch();
                void actionsQuery.refetch();
              }}
              className="text-accent underline"
            >
              try again
            </button>{" "}
            or{" "}
            <Link to="/home" className="text-accent underline">
              go back
            </Link>
            .
          </p>
        </div>
      ) : (
        <ActivityDashboard
          analytics={analyticsQuery.data}
          users={usersQuery.data ?? []}
          actions={actionsQuery.data ?? []}
        />
      )}
    </AdminShell>
  );
}
